<template>
  <section style="padding:0 15px;">
    <div class="appendix" v-if="attachmentArr.length">
      <div style="color:#d93c37;">
        * 当前附件
        <span v-if="flowId">(附件可在审批进行中动态修改)</span>
      </div>
      <div class="item" v-for="item,i in attachmentArr">
        <el-tooltip
          v-if="((hasAuthority && !flowId) || item.canDelete) || isSystemAdmin()"
          effect="dark"
          content="删除附件"
          placement="bottom"
        >
          <i class="iconfont icon-close" @click="deleteAppendix(i, item)"></i>
        </el-tooltip>

        <i class="iconfont icon-link"></i>
        <file-link :item="item"></file-link>
        <a
          v-if="!isMobile"
          :href="baseURL+'/common/file/download?dz='+encodeURI(item.fileUrl)"
          style="margin-left:5px;"
          target="_blank"
        >
          <el-button size="mini">下载</el-button>
        </a>
      </div>
    </div>

    <el-upload
      style="margin-right:5px;"
      v-if="hasAuthority && !isMobile"
      v-for="at,i in atype"
      :key="i"
      class="attachments-upload"
      :before-upload="handleBeforeUpload"
      :action="uploadUrl"
      multiple
      :data="{ name:(at=='其他附件(文件命名后上传)'||at=='点击上传')?'':at }"
      :on-success="handleAvatarSuccess"
      :show-file-list="false"
    >
      <el-button size="small" type="primary" :loading="isUpload">{{at}}</el-button>
    </el-upload>

    <div class="other-attachments" v-if="otherAttachmentArr.length>0">
      <div style="color:#d93c37;">* 可添加至当前表格的附件（项目负责人可点击后面的"+"号插入当前审批中）</div>
      <div class="appendix">
        <div class="item" v-for="item,i in otherAttachmentArr">
          <el-tooltip
            v-if="hasAuthority && !isMobile && !isFlowPass"
            class="item"
            effect="dark"
            content="点击添加到当前审批的附件中"
            placement="left"
          >
            <el-button
              style="float:right;"
              @click="attachmentArrPlus(item, i)"
              type="primary"
              icon="el-icon-plus"
              circle
            ></el-button>
          </el-tooltip>

          <i class="iconfont icon-link"></i>
          <file-link :item="item"></file-link>
          <a
            v-if="!isMobile"
            :href="baseURL+'/common/file/download?dz='+encodeURI(item.fileUrl)"
            style="margin-left:5px;"
            target="_blank"
          >
            <el-button size="mini">下载</el-button>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import Role from "@/Mixins/role";
import FileLink from "@/components/FileLink";
export default {
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
      isMobile: (state) => state.main.isMobile,
    }),
  },
  components: {
    FileLink,
  },
  mixins: [Role],
  props: [
    "type",
    "arr",
    "flowId",
    "flowUser",
    "approvalUserData",
    "form",
    "projectId",
    "contractId",
  ],
  data() {
    return {
      baseURL: axios.defaults.baseURL,
      // 其他相关附件
      otherAttachmentArr: [],
      otherRelateFiles: "",
      isFlowPass: false,

      atype: [],
      hasAuthority: false,
      isUpload: false,
      uploadUrl: axios.defaults.baseURL + "/common/upload",
      attachmentArr: [],
      attachmentType: {
        a_990: ["点击上传"],
        a_991: ["验收报告", "其他附件(文件命名后上传)"],
        a_992: ["许可证", "开工报告", "其他附件(文件命名后上传)"],
        a_993: ["联系单", "会议纪要", "其他附件(文件命名后上传)"],
        a_994: [
          "可研批复",
          "项建批复",
          "初设批复",
          "实施方案批复",
          "其他附件(文件命名后上传)",
        ],
        a_995: ["会议资料"],
        a_996: ["中标通知书", "其他附件(文件命名后上传)"],
        a_997: [
          "一审付款审批表",
          "二审付款审批表",
          "财政局付款审批表",
          "其他附件(文件命名后上传)",
        ],
        a_998: [
          "预算书",
          "甲供材料和设备清单",
          "审核意见书",
          "其他附件(文件命名后上传)",
        ],

        a_2: [
          "情况说明",
          "现场照片",
          "检测报告",
          "会议纪要",
          "其他附件(文件命名后上传)",
        ],
        a_4: ["招标控制价", "甲供材料和设备清单", "其他附件(文件命名后上传)"],
        a_10: ["招标文件", "其他附件(文件命名后上传)"],
        a_11: [
          "施工合同",
          "设计合同",
          "监理合同",
          "勘探合同",
          "测绘合同",
          "检测合同",
          "配套维护合同",
          "其他附件(文件命名后上传)",
        ],
        a_5: ["月度完成工程量造价", "其他附件(文件命名后上传)"],
        // a_6: ['进度款审核意见单', '其他附件(文件命名后上传)'],
        // a_8: ['需求填报过的相关合同（设计合同、监理合同、勘探合同、测绘合同、检测合同', '其他附件(文件命名后上传)'],
        a_14: ["相关合同", "进度款审核意见单", "其他附件(文件命名后上传)"],
        a_40: ["相关合同", "进度款审核意见单", "其他附件(文件命名后上传)"],
        a_50: ["材料明细单", "其他附件(文件命名后上传)"],
      },
    };
  },
  mounted() {
    if (this.form) {
      this.isFlowPass = this.form.flow.status == "审批通过" ? true : false;
    }

    if (this.arr) {
      this.attachmentArr = this.arr;
    }
    if (this.flowUser) {
      if (
        this.flowUser.id == this.userData.id ||
        this.isApprovalUser() ||
        this.isLeader()
      ) {
        this.hasAuthority = true;
      }
    } else {
      this.hasAuthority = true;
    }

    this.atype = this.attachmentType["a_" + this.type];

    // console.log(this.contractId)
    // console.log(this.projectId)
    // console.log(this.attachmentType['a_' + this.type])
    console.log(this.hasAuthority);

    this.getOtherAttachment();
  },
  methods: {
    // 添加更多附件到当前审批
    attachmentArrPlus(item, index) {
      item.canDelete = true;
      this.attachmentArr.push(item);
      this.otherAttachmentArr.splice(index, 1);
      this.updateFlowAttachments();
      this.$message.success("从历史附件中选择添加附件成功");
    },
    // 汇总更多附件的下载列表 (工程)
    getOtherAttachmentByProject() {
      let _apply = this.otherRelateFiles.applyAttas;
      let _pay = this.otherRelateFiles.payAttas;
      let _setup = this.otherRelateFiles.setupAttas;
      let _ss = this.otherRelateFiles.ssAttas;
      let _zbht = this.otherRelateFiles.zbhtAttas;
      this.otherAttachmentArr = _apply.concat(
        _setup.concat(_zbht.concat(_ss.concat(_pay)))
      );
    },
    // 汇总更多附件的下载列表 (合同)
    getOtherAttachmentByContract() {
      let _ht = this.otherRelateFiles.htAttas;
      let _pay = this.otherRelateFiles.payAttas;
      let _zb = this.otherRelateFiles.zbAttas;
      this.otherAttachmentArr = _zb.concat(_ht.concat(_pay));
    },
    getOtherAttachment() {
      if (this.projectId) {
        // 这里有工程的取工程的附件
        ajax.get("/gc/project/relate/files/" + this.projectId, "", (res) => {
          this.otherRelateFiles = res.vo;
          this.getOtherAttachmentByProject();
        });
      } else if (this.contractId) {
        // 没有工程的才去合同的附件
        ajax.get("/contract/relate/files/" + this.contractId, "", (res) => {
          this.otherRelateFiles = res.vo;
          this.getOtherAttachmentByContract();
        });
      }
    },

    // 项目负责人也有权限
    isLeader() {
      // console.log(this.form)
      let _object = this.form.project;
      if (!_object || !_object.leader) {
        _object = this.form.contractVO;
      }
      if (!_object) {
        return false;
      }

      let _r = false;
      if (
        _object &&
        (_object.leader.id == this.userData.id ||
          _object.creator.id == this.userData.id)
      ) {
        _r = true;
      }
      return _r;
    },
    // 审批人也有附件权限
    isApprovalUser() {
      let _r = false;
      for (let i = 0; i < this.approvalUserData.length; i++) {
        if (
          this.approvalUserData[i].user &&
          this.approvalUserData[i].user.id == this.userData.id
        ) {
          _r = true;
        }
      }
      return _r;
    },

    handleBeforeUpload(file) {
      console.log(file);
      this.isUpload = true;
    },
    // 直接更新流程附件
    updateFlowAttachments() {
      // 如果存在flowId， 那么更新附件
      if (this.flowId) {
        ajax.post(
          "/gc/project/flow/attachments/edit",
          {
            flowId: this.flowId,
            attachments: this.getAttachments(),
          },
          (res) => {}
        );
      }
    },
    // 上传成功回调
    handleAvatarSuccess(res, file) {
      this.attachmentArr.push(res.vo);
      this.isUpload = false;
      this.updateFlowAttachments();
    },
    // 删除某附件
    deleteAppendix(index, item) {
      this.attachmentArr.splice(index, 1);
      this.updateFlowAttachments();

      if (this.contractId) {
        this.getOtherAttachmentByContract();
      }
      if (this.projectId) {
        this.getOtherAttachmentByProject();
      }
    },
    // 组件获取附件IDS
    getAttachments() {
      if (this.attachmentArr && this.attachmentArr.length > 0) {
        return this.attachmentArr.map((item) => item.id).join();
      } else {
        return "";
      }
    },
  },
  watch: {
    arr() {
      this.attachmentArr = this.arr;
    },
    projectId() {
      this.getOtherAttachment();
    },
    contractId() {
      this.getOtherAttachment();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Attachments.vue